/* eslint-disable @angular-eslint/component-selector */
import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ROLES, SWAL, logo } from 'src/app/app-const';
import {
  AuthenticationService,
  MgApplicationUser,
} from 'src/app/core/services/auth.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';

interface ISystem {
  name: string;
  logo: string;
  link?: string | null;
  roles?: string[];
  other?: number;
  display?: boolean;
  event?: boolean;
}
@Component({
  selector: 'mg-system-chooser',
  templateUrl: './system-chooser.component.html',
  styleUrls: ['./system-chooser.component.scss'],
})
export class SystemChooserComponent {
  acc: MgApplicationUser | null = null;
  logos = logo;
  isHovered: boolean = false;
  ROLEs = ROLES;
  systems: ISystem[] = [];
  systemsParent: ISystem[] = [];

  // toggleOther(system) {
  //   if(system.other===1){
  //     system.other = 3;
  //   }else if(system.other ===3)
  //     system.other = 1;
  // }
  // handleClick(system) {
  //   if (system.event) {
  //     this.toggleOther(system);
  //     // Prevent the default behavior
  //     // You can also perform additional actions here
  //     return false;
  //   }
  //   return true;
  // }

  // handleClick(system, event: MouseEvent) {
  //   if (system.event) {
  //     // Toggle system.other
  //     this.toggleOther(system);

  //     // Prevent the default behavior
  //     event.preventDefault();

  //     // You can also perform additional actions here
  //   }
  // }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.ROlesCanSeeUserManager();
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: SpinnerService,
    private authenticationService: AuthenticationService,
  ) {
    spinner.showSpinner();
    authenticationService.identity().subscribe({
      next: (res) => {
        this.acc = res;
        this.setSystems();
        this.setSystemsParent();
        setTimeout(() => {
          spinner.hideSpinner();
        }, 100);
      },
      error: (error) => {
        spinner.hideSpinner();
        if (error?.isLockout) {
          SWAL('error', 'LOCKED');
        } else {
          SWAL('error', error?.errorCode);
        }
      },
    });
  }

  RolesCanSeeUserManager() {
    return this.acc?.roles?.some((r) => r == ROLES.ADMIN) ?? false;
  }
  toggleDisplay(system) {
    system.display = !system.display;
  }
  setSystems() {
    this.systems = [
      // {
      //   name: 'أنظمة أخرى',
      //   logo: '/assets/images/login-screen/gen-icon.svg',
      //   link: null,
      //   event:true,
      //   other:2

      // },
      {
        name: ' المشتل',
        link:
          this.acc?.roles?.includes(ROLES.CAN_CONFIRM_NURSERY_ORDERS) &&
          !this.acc?.roles?.includes(ROLES.ADMIN) &&
          !this.acc?.roles?.includes(ROLES.NURSERY_EMPLOYEE) &&
          !this.acc?.roles?.includes(ROLES.NURSERY_MANAGER)
            ? '/plant-nursery/orders'
            : '/plant-nursery',
        logo: '/assets/images/login-screen/pn-icon.svg',
        roles: [ROLES.CAN_USE_NURSERY_MANAGER, ROLES.ADMIN],
        other: 1,
        display: false,
      },
      {
        name: 'نظام مخالفات الجوامع',
        link: 'https://dms-riyadh.com:3000',
        logo: '/assets/images/login-screen/mosqe-icon.svg',
        other: 1,
        roles: [ROLES.CAN_USE_NURSERY_MANAGER, ROLES.ADMIN],
        display: false,
      },
      {
        name: 'نظام حصر الحدائق',
        link: 'https://dms-riyadh.com:2000/',
        logo: '/assets/images/login-screen/garden-icon.svg',
        other: 1,
        roles: [ROLES.CAN_USE_NURSERY_MANAGER, ROLES.ADMIN],
        display: false,
      },
      // {
      //   name: 'نظام قياس الآداء',
      //   link: '',
      //   logo: '/assets/images/login-screen/PP-icon.svg'
      // },
      // {
      //   name: 'إعدادات النظام ',
      //   link: '/system-setting',
      //   logo: '/assets/images/login-screen/setting.svg',
      //   roles: [ROLES['Admin']],
      // },
    ];
  }
  setSystemsParent() {
    this.systemsParent = [
      {
        name: '  نظام إدارة المهام',
        link: '/task-manager',
        logo: '/assets/images/login-screen/tm-icon.svg',
        roles: [ROLES.CAN_USE_TASK_MANAGER, ROLES.ADMIN],
        other: 2,
      },
      {
        name: 'نظام إدارة المشاريع',
        link: this.acc?.roles?.some(
          (r) =>
            r === ROLES.ADMIN ||
            r === ROLES.DIRECTOR_OF_ADMINISTRATION ||
            r === ROLES.EMPLOYEE ||
            r === ROLES.REVIEWER,
        )
          ? '/pmo'
          : '/pmo/projects?type=Contracted',
        logo: '/assets/images/login-screen/pm-icon.svg',
        roles: [
          ROLES.CAN_USE_PROJECT_MANAGER,
          ROLES.ADMIN,
          ROLES.DIRECTOR_OF_ADMINISTRATION || ROLES.EMPLOYEE || ROLES.REVIEWER,
          ROLES.CONTRACTOR,
        ],
        other: 2,
      },

      // {
      //   name: 'نظام قياس الآداء',
      //   link: '',
      //   logo: '/assets/images/login-screen/PP-icon.svg'
      // },
      // {
      //   name: 'إعدادات النظام ',
      //   link: '/system-setting',
      //   logo: '/assets/images/login-screen/setting.svg',
      //   roles: [ROLES['Admin']],
      // },
    ];
  }
  logout() {
    this.authenticationService.logout();
  }
}
